import { Component } from '@angular/core';

@Component({
    selector: 'app-aerocalc',
    templateUrl: './aerocalc.component.html',
    styleUrl: './aerocalc.component.scss',
    standalone: false
})
export class AerocalcComponent {

}
